module.exports = __webpack_public_path__ + "static/media/Artboard 1 copy 127.4aae0a04.png";